import React, { Component } from 'react';

// Import assets
import warningIcon from '../assets/images/warning.png';

// Import components
import PayixButton from '../containers/payix-button';

class LinkingLoanAccountError extends Component {
  /**
   * Render the component view.
   */
  render() { 
    return (
      <div>
        <div className="modal__header">
          <div className="modal__header-content--centered">
            <img src={ warningIcon } alt="" />
          </div>
        </div>

        <div className="modal__body">
          <div className="modal__body-content--pad35 text-center">
            <p className="modal-paragraph">
              We couldn`t link your account
              <br />
              Would you like to try again or notify your lender?
            </p>

            <div className="form-group form-group--row-layout">
              <PayixButton className="size-50per margin-right-10" onClick={ this.props.onTryAgain }>
                TRY AGAIN
              </PayixButton>

              <PayixButton className="size-50per margin-right-10" onClick={ this.props.onNotifyLender }>
                NOTIFY LENDER
              </PayixButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default LinkingLoanAccountError;


// WEBPACK FOOTER //
// ./src/components/linking-loan-account-error.js